import { MenuItem } from '@mui/material';
import { FC } from 'react';
import { useQuery } from 'react-query';
import { getUserJobTitles } from '../../fetch';
import { IJobTitle } from '../../models';
import { SMBSelect } from '../input';
import { alphaSort } from '../../helpers';

interface IJobTitleDropdownProps {
  value: string;
  handleChange: (val: string, option?: IJobTitle) => void;
  isDisabled?: boolean;
  setOptions?: (val: IJobTitle[]) => void;
  apiParams?: any;
  isExternal?: boolean;
  isRequired?: boolean;
  inputLabel?: string;
  handleClear?: () => void;
}

export const JobTitlesDropdown: FC<IJobTitleDropdownProps> = ({
  inputLabel,
  isDisabled,
  isRequired,
  value,
  handleChange,
  setOptions,
  apiParams,
  handleClear,
  isExternal
}) => {
  const { isLoading: isLoadingJobTitles, data: jobTitles } = useQuery<IJobTitle[], Error>(
    ['job-titles-filters', apiParams, isExternal],
    () => getUserJobTitles({ ...apiParams, isExternal: isExternal }),
    {
      notifyOnChangeProps: 'tracked',
      onSuccess: d => setOptions?.(d)
    }
  );

  return (
    <SMBSelect
      label={isLoadingJobTitles ? 'Loading...' : inputLabel ?? 'Job Title'}
      disabled={isDisabled || isLoadingJobTitles}
      name="jobTitle"
      id="jobTitle"
      variant="outlined"
      value={value}
      required={isRequired}
      onChange={({ target: { value } }) => {
        const selected = jobTitles?.find(jt => jt.value === Number(value));
        handleChange(value, selected);
      }}
      handleClear={() => {
        handleChange('');
        handleClear && handleClear();
      }}
      SelectProps={{
        MenuProps: {
          sx: {
            maxHeight: '30rem'
          }
        }
      }}
    >
      {!isLoadingJobTitles && !jobTitles && <MenuItem disabled>No job titles available</MenuItem>}
      {!isLoadingJobTitles &&
        jobTitles &&
        alphaSort(jobTitles, 'shorthand').map((jobTitle, index) => {
          return (
            <MenuItem key={`${index}`} value={jobTitle.value}>
              {jobTitle.description}
            </MenuItem>
          );
        })}
    </SMBSelect>
  );
};
